<ng-container *ngIf="control.touched && control.errors?.['required']">This field is required</ng-container>
